import React, { useEffect, useState } from 'react'
import NuDateFormat from '../../../utils/NuDate';
import ViewMore from './viewMore';
import { TableLoader } from '../../../components/Loader';
import axiosInstance from '../../../services/axiosComman';
import Swal from 'sweetalert2';
import CreateorUpdate from './from';
import BackupScreen from './BackupScreen';

const Toast = Swal.mixin({
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

function BackupAndRestoreIndex() {
  const [showMyMenu, setShowMyMenu] = useState(false);
  const handleOnCloseMenu = () => setShowMyMenu(false);
  const [data,setData] = useState([])
  const [showMyModal, setShowMyModal] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const handleFileOnClose = () => setShowFileUpload(false);
  const [complete,setComplete] = useState(0);
  const [isLoading,setIsLoading]=useState(true)
  
  function backupFun() {
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to Backup  ?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Backup'
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowMyModal(true);
        axiosInstance.get(`/Auth/backup`).then(res=>{
          if(res.data.msg=="Backup completed successfully"){
            setComplete(100)
            Toast.fire({
              icon: "success",
              title: res.data.msg || "Data backup was Successful.",
            });
    refreshData()

           setShowMyModal(false);
            Swal.fire({
            icon:"success",
            title: `Backup has completed.`,
            html:`
            Click here to close this window
            `,
            // showConfirmButton: false,
            // timer: 2000,
            width:"35%",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Close',
          });
          }else{
            Toast.fire({
              icon: "error",
              title: res.data.msg || "Data backup was unsuccessful.",
            });
           setShowMyModal(false);

          }
        }).catch((error) => {
          Toast.fire({
            icon: "error",
            title: error?.response?.data?.msg || "Data backup was unsuccessful.",
          });
          setShowMyModal(false);

        })
      }
    })
  }


  // const { data, error, mutate } = useSWR(`/email_templates/standard/${id}`, fetcher);


  const refreshData = () => {
    axiosInstance.get(`/Auth/available_files`).then(res=>{
      let tempdata = res?.data?.data||[] 
      let finalArr = []
      res?.data?.data && tempdata.forEach(item=>{
        // if(item?.isActive&&item?.keyActivated){
          item?.files &&  item?.files.map(file=>{
          finalArr.push(file);
          })
        // }
      })
      res?.data?.data && setData(finalArr)
      setIsLoading(false)
    }).catch()
  };




  useEffect(()=>{
    refreshData()
  },[])

  return (
    <>
    <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
      <div className="pb-2 px-2 flex justify-between items-center w-full">
        <h4 className="text-sm 2xl:text-base font-medium text-heading">
        Backup & Restore
        </h4>
        <div className=" flex gap-2 items-center">
            <button className=" bg-[#7030A0] py-1 text-xs px-3 text-white rounded-md" onClick={backupFun}>Backup</button>
             <button className=" bg-[#7030A0] py-1 text-xs px-3 text-white rounded-md" onClick={() => setShowFileUpload(true)}>Manual Restore</button> 
        </div>
      </div>
      <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
        <div className=" sticky top-0 z-10">
          <table className="table-auto w-full">
            <thead className="bg-tabletitle">
              <tr className="flex items-center text-xs 2xl:text-sm font-medium">
                {header?.map((header) => (
                  <th className={`text-center px-5 py-4 ${header.width}`}>
                    {header?.headone}
                  </th>
                ))}
              </tr>
            </thead>
          </table>
        </div>
        <div>
          <table className="table-auto w-full">
            {isLoading == true ? (
              <>
                {[...Array(10)].map((_, index) => {
                  return <TableLoader key={index} header={header} />;
                })}
              </>
            ) : (
              <>
                {data &&
                  data.map((item, i) => (
                    <tr className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm  py-1 flex justify-between items-center my-1">
                    <td className="text-center text-gray-900 w-[10%]">
                      {data.length - i}
                    </td>
                    <td className="text-center text-gray-900 capitalize w-[47%] ">
                      {item.filename|| "-"}
                    </td>
                    <td className="text-center text-gray-900 capitalize w-[13%] ">
                      {item.size|| "0 KB"}
                    </td>
                    <td className="text-center text-gray-900 capitalize w-[13%] ">
                    { item?.datetime != "None" && item?.datetime != " " && NuDateFormat({
                              value:`${item?.datetime}+0530 `,
                              format: "DD-MMM-yyyy",
                            })||"-"}
                    
                    </td>
                    <td className="text-center text-gray-900 capitalize w-[13%] ">
                    {/* {console.log("Date format", new Date(`${data?.date} ${data?.time}`))} */}
                    { item?.datetime != "None" && item?.datetime != " " && NuDateFormat({
                              value: `${item?.datetime}+0530 `,
                              format: "HH:mm",
                            })||"-"}
                    </td>
                    <td className=" w-[4%]">
                      <div>
                      <ViewMore
                      onClose={handleOnCloseMenu}
                      visible={showMyMenu}
                      data={item}
                      fetcher={refreshData}
                    />
                      </div>
                    </td>
                  </tr>
                  ))}
              </>
            )}
          </table>
        </div>
      </div>
    </div>
    <CreateorUpdate
        onClose={handleFileOnClose}
        visible={showFileUpload}
        refreshData={refreshData}
      /> 
      <BackupScreen
      complete={complete}
              //  onClose={handleOnClose}
               visible={showMyModal}
              //  refreshData={refreshData}
      />
  </>
  )
}

export default BackupAndRestoreIndex;


const header = [
  {
    headone: "SI. No",
    width: "w-[10%]",
  },
  {
    headone: "File Name",
    width: "w-[47%]",
  },
  {
    headone: "Size",
    width: "w-[13%]",
  },
  {
    headone: " Date",
    width: "w-[13%]",
  },
  {
    headone: "Time",
    width: "w-[13%]",
  },
  {
    headone: " ",
    width: "w-[4%]",
  }
];